import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import { slideshow as slideshowPropType } from 'lib/CustomPropTypes';

import Link from 'components/Link';
import Picture from 'components/Picture';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import { imageAltForItem } from 'lib/imageAlt';

import slideshowStyles from './styles.module.scss';
import todayStyles from '../styles.module.scss';

function Slideshow(props) {
  const { content } = props;

  return (
    <div className={todayStyles.todayCard}>
      <div className={todayStyles.imageWrapper}>
        <Picture
          url={content.teaseImage.url.primary}
          responsiveFlavors={{
            s: AIMS_FLAVORS.FOCAL_600x300,
            m: AIMS_FLAVORS.FOCAL_720x360,
            l: AIMS_FLAVORS.FOCAL_920x460,
            xl: AIMS_FLAVORS.FOCAL_860x430,
          }}
          className={todayStyles.coverImage}
          alt={imageAltForItem(content)}
        />
        <div className={classNames(todayStyles.cta, slideshowStyles.cta)}>
          <Link to={content.url.primary}>
            <span className="icon icon-gallery" />
            {content.slides.length}
            {' '}
            { i18next.t('photos') }
          </Link>
        </div>
        {content.teaseImage.source && (
          <span className={todayStyles.byline}>
            {content.teaseImage.source.name}
          </span>
        )}
      </div>

      <div
        className={classNames(todayStyles.summaryContainer, slideshowStyles.summaryContainer)}
      >
        <div className={slideshowStyles.fullscreenCta}>
          <Link to={content.url.primary}>
            <span className="icon icon-full-screen" />
          </Link>
        </div>
        <div className={todayStyles.titleContainer}>
          <span className={slideshowStyles.eyebrow}>{ i18next.t('Slideshow') }</span>
          <h3 className={todayStyles.title}>
            <Link to={content.url.primary}>
              {content.headline.primary}
            </Link>
          </h3>
        </div>
        <div className={slideshowStyles.summary}>
          {content.description.primary}
        </div>
        <div className={todayStyles.accentBorder} />
      </div>
    </div>
  );
}

Slideshow.propTypes = {
  content: slideshowPropType.isRequired,
};

export default Slideshow;
